// extracted by mini-css-extract-plugin
export default {"about":"About_about__E2SU4","rightAbout":"About_rightAbout__bIOI6","grid":"About_grid__UgjxC","option":"About_option__dafwB"};